
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ProjectsDocumentsFilteredList from "@/components/documents/ProjectsDocumentsFilteredList.vue";

  import { User, Company } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      ProjectsDocumentsFilteredList,
    },
  })
  export default class DocumentsManagerProjects extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    RouteNames: typeof RouteNames = RouteNames;
  }
